<div class="leads-wrapper">
  <nz-card class="hero-card">
    <div class="hero-content">
      <div>
        <h2>Lead Pipeline</h2>
        <p class="muted-text">Monitor lead progress and follow up while they are warm.</p>
      </div>
      <span class="total-pill" *ngIf="leads?.length">Total: {{ leads?.length | number }}</span>
    </div>
  </nz-card>

  <nz-card class="table-card">
    <div class="table-header">
      <nz-input-group nzPrefixIcon="search" class="search-input">
        <input
          nz-input
          placeholder="Search leads"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchChange($event)" />
      </nz-input-group>
    </div>

    <div class="table-scroll">
      <nz-table #leadsTable class="leads-table" [nzData]="filteredLeads" nzBordered [nzLoading]="isLoading" [nzFrontPagination]="false"
        [nzNoResult]="leadEmpty">
        <thead>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Created</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lead of leadsTable.data" class="lead-row">
            <td>
              <div class="cell-primary">
                <span class="name">{{ lead.first_name | titlecase }} {{ lead.last_name | titlecase }}</span>
                <span class="subtext" *ngIf="lead.provider">{{ lead.provider | titlecase }}</span>
              </div>
            </td>
            <td>
              <div class="cell-primary">
                <span>{{ lead.address_line_1 | titlecase }}</span>
                <span class="subtext">{{ lead.address_city | titlecase }}, {{ lead.address_state }}</span>
              </div>
            </td>
            <td>
              <span class="cell-primary">{{ lead.created_at | date:'short' }}</span>
            </td>
            <td>
              <nz-tag [nzColor]="getStatusColor(lead.status)">
                {{ lead.status ? (lead.status | titlecase) : 'Pending' }}
              </nz-tag>
            </td>
            <td>
              <div class="actions-cell">
                <button
                  *ngIf="isDishLead(lead) || isStarlinkLead(lead); else noReplay"
                  nz-button
                  nzType="primary"
                  nz-popconfirm
                  nzPopconfirmTitle="Replay this lead?"
                  nzOkText="Replay"
                  nzCancelText="Cancel"
                  (nzOnConfirm)="startReplay(lead)"
                  [nzLoading]="replayLoadingId != null && replayLoadingId === (lead.customer_id || lead.id)">
                  Replay Lead
                </button>
                <ng-template #noReplay>
                  <span class="subtext">Not available</span>
                </ng-template>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-card>
</div>

<ng-template #leadEmpty>
  <div class="empty-state">
    <span nz-icon nzType="inbox" nzTheme="outline"></span>
    <p>No leads to show yet.</p>
  </div>
</ng-template>
